import { createAsyncThunk } from "@reduxjs/toolkit";
import { loadingActions } from "../LoaderSlice";
import { JEDI_HR_URL } from "../../constants";
import axiosClient from "../../utils/axiosClient";
import { modalActions } from "../ModalSlice";

export const updateEssMss = createAsyncThunk(
  "manager/update_ess_mss",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    dispatch(loadingActions.setLoading(true));

    console.log("inside updateEssMss", payload);
    const baseURL = "https://" + JEDI_HR_URL;
    const path = "/update_ess_mss";
    const url = baseURL + path;

    try {
      const response = await axiosClient.post(url, payload);

      dispatch(loadingActions.setLoading(false));
      console.log("updateEssMss response", response);
      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error : " +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          })
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message
        );
      }
      return response.data;
    } catch (error) {
      console.log("Error22121 : ", error?.response);

      dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: "Error : " + error?.response?.data?.message,
          status: error.status,
          state: true,
        })
      );
      return rejectWithValue(error);
    }
  }
);

export const getEssMssFields = createAsyncThunk(
  "manager/get_ess_mss_fields",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside getEssMssFields : ", payload);

    const baseURL = "https://" + JEDI_HR_URL;

    const path = "/get_ess_mss_fields";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      dispatch(loadingActions.setLoading(false));
      console.log("getEssMssFields response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error : " +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          })
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error11 : ", error.message);

      dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        })
      );
      return rejectWithValue(error);
    }
  }
);
